<template>
  <div>
    <div>
      <div>
        <article class="box">
          <p class="title">Annotations</p>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">RR</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.RR] }">
                  <textarea class="textarea"
                    v-model="getAnnotation(remarkTypes.RR).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.RR]"
                    @focus="captureAnnotationSnapshot(remarkTypes.RR)"
                    @blur="handleAnnotationBlur(remarkTypes.RR)" />
                </div>
              </div>
              <div class="field">
                <label class="label">REP</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.REP] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.REP).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.REP]"
                    @focus="captureAnnotationSnapshot(remarkTypes.REP)"
                    @blur="handleAnnotationBlur(remarkTypes.REP)" />
                </div>
              </div>
              <div class="field">
                <label class="label">FIBER</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.FIBER] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.FIBER).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.FIBER]"
                    @focus="captureAnnotationSnapshot(remarkTypes.FIBER)"
                    @blur="handleAnnotationBlur(remarkTypes.FIBER)" />
                </div>
              </div>
              <div class="field">
                <label class="label">CD</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.CD] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.CD).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.CD]"
                    @focus="captureAnnotationSnapshot(remarkTypes.CD)"
                    @blur="handleAnnotationBlur(remarkTypes.CD)" />
                </div>
              </div>
              <div class="field">
                <label class="label">PART</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.PART] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.PART).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.PART]"
                    @focus="captureAnnotationSnapshot(remarkTypes.PART)"
                    @blur="handleAnnotationBlur(remarkTypes.PART)" />
                </div>
              </div>
              <div class="field">
                <label class="label">MISC</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.MISC] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.MISC).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.MISC]"
                    @focus="captureAnnotationSnapshot(remarkTypes.MISC)"
                    @blur="handleAnnotationBlur(remarkTypes.MISC)" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">RWA</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.RWA] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.RWA).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.RWA]"
                    @focus="captureAnnotationSnapshot(remarkTypes.RWA)"
                    @blur="handleAnnotationBlur(remarkTypes.RWA)" />
                </div>
              </div>
              <div class="field">
                <label class="label">PAINT</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.PAINT] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.PAINT).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.PAINT]"
                    @focus="captureAnnotationSnapshot(remarkTypes.PAINT)"
                    @blur="handleAnnotationBlur(remarkTypes.PAINT)" />
                </div>
              </div>
              <div class="field">
                <label class="label">CRUSH</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.CRUSH] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.CRUSH).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.CRUSH]"
                    @focus="captureAnnotationSnapshot(remarkTypes.CRUSH)"
                    @blur="handleAnnotationBlur(remarkTypes.CRUSH)" />
                </div>
              </div>
              <div class="field">
                <label class="label">MECH</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.MECH] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.MECH).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.MECH]"
                    @focus="captureAnnotationSnapshot(remarkTypes.MECH)"
                    @blur="handleAnnotationBlur(remarkTypes.MECH)" />
                </div>
              </div>
              <div class="field">
                <label class="label">OPG</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.OPG] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.OPG).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.OPG]"
                    @focus="captureAnnotationSnapshot(remarkTypes.OPG)"
                    @blur="handleAnnotationBlur(remarkTypes.OPG)" />
                </div>
              </div>
              <div class="field">
                <label class="label">SUBLET</label>
                <div class="control"
                  :class="{ 'is-loading': savingAnnotations[remarkTypes.SUBL] }">
                  <textarea
                    class="textarea"
                    v-model="getAnnotation(remarkTypes.SUBL).remarks"
                    :rows="rows"
                    :disabled="!!savingAnnotations[remarkTypes.SUBL]"
                    @focus="captureAnnotationSnapshot(remarkTypes.SUBL)"
                    @blur="handleAnnotationBlur(remarkTypes.SUBL)" />
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { RemarkTypes, EventHubTypes } from '@/enums'
import Guid from '@/components/Guid'
import RemarkService from '@/services/RemarkService'

export default {
  name: 'QuoteAnnotations',
  props: {
    value: null,
    autoSaveEnabled: { type: Boolean, default: false }
  },
  data() {
    return {
      innerValue: null,
      rows: 2,
      savingAnnotations: {},
      annotationSnapshots: {},
      draftAnnotations: {}
    }
  },
  computed: {
    remarkTypes() {
      return RemarkTypes
    },
    displayedRemarkTypes() {
      return [
        RemarkTypes.RR, RemarkTypes.REP, RemarkTypes.FIBER, RemarkTypes.CD,
        RemarkTypes.PART, RemarkTypes.MISC, RemarkTypes.RWA, RemarkTypes.PAINT,
        RemarkTypes.CRUSH, RemarkTypes.MECH, RemarkTypes.OPG, RemarkTypes.SUBL
      ]
    }
  },
  created() {
    this.innerValue = this.value
    this.initAnnotations()
  },
  beforeDestroy() {
    this.$eventHub.$off(EventHubTypes.EntitySaved)
  },
  mounted() {
    this.$eventHub.$on(EventHubTypes.EntitySaved, () => {
      this.innerValue = this.value
      this.initAnnotations()
    })
  },
  methods: {
    initAnnotations() {
      // Drafts for missing remark types; promoted to the entity only on edit
      // (see handleAnnotationBlur), so empty rows aren't flagged as unsaved.
      this.draftAnnotations = {}
      for (const remarkType of this.displayedRemarkTypes) {
        const existing = this.innerValue.annotations.find(r => r.remarkTypeId === remarkType)
        if (!existing) {
          this.$set(this.draftAnnotations, remarkType, {
            isAlert: false,
            isDeleted: false,
            isNew: true,
            remarkDateTime: new Date(),
            remarkId: Guid.newGuid(),
            remarkTypeId: remarkType,
            assetId: this.innerValue.quoteId,
            remarks: ''
          })
        }
      }
    },
    getAnnotation(remarkType) {
      const existing = this.innerValue.annotations.find(r => r.remarkTypeId === remarkType)
      if (existing) return existing
      return this.draftAnnotations[remarkType]
    },
    captureAnnotationSnapshot(remarkType) {
      this.$set(this.annotationSnapshots, remarkType, this.getAnnotation(remarkType).remarks)
    },
    async handleAnnotationBlur(remarkType) {
      const annotation = this.getAnnotation(remarkType)
      if (annotation.remarks === this.annotationSnapshots[remarkType]) return
      // Promote the draft to the entity so both manual save and autosave see it.
      // Must run before the autosave gate below.
      if (annotation.isNew && !this.innerValue.annotations.includes(annotation)) {
        this.innerValue.annotations.push(annotation)
      }
      if (!this.autoSaveEnabled) return
      this.$set(this.savingAnnotations, remarkType, true)
      this.$eventHub.$emit(EventHubTypes.AutoSaveAnnotationsStatus, { isSaving: true })
      try {
        if (annotation.isNew) {
          await RemarkService.postEntity(annotation)
          annotation.isNew = false
        } else {
          await RemarkService.putEntity(annotation)
        }
        this.$eventHub.$emit(EventHubTypes.AutoSaveAnnotationsStatus, { isSaving: false, isFailed: false })
      } catch (e) {
        this.$eventHub.$emit(EventHubTypes.AutoSaveAnnotationsStatus, {
          isSaving: false,
          isFailed: true,
          failMessage: e?.message || 'Save failed'
        })
      } finally {
        this.$set(this.savingAnnotations, remarkType, false)
      }
    }
  }
}
</script>
